import store from 'app/store';
import { FuseLoadable } from '@fuse';

export const Index = {
    auth: ['admin', 'sub-admin', 'transport', 'sub-transport'],
    routes: [
        {
            path: '/hauler-pay-reports',
            component: FuseLoadable({
                loader: () => {
                    switch (store.getState().persisted.auth.user.role) {
                        case 'admin':
                        case 'sub-admin':
                            return import('./AdminHaulerPayReportsApp');
                        case 'transport':
                        case 'sub-transport':
                            return import('./HaulerPayReportsHaulerApp');
                        default:
                            break;
                    }
                },
            }),
        },
    ],
};

export default [Index];
